import { AgGridTable } from 'components/tables/AgGridTable';

export default function OrderProductLogsActivity({ col, mainGridApiRef, getRows, pageRef, loading }) {
    return (
        <AgGridTable col={col} mainGridApiRef={mainGridApiRef} getRows={getRows} pageRef={pageRef} isLoading={loading} style={{ height: '70vh' }} maxLimit={20} />

    );
}